<template>
  <a
    :href="prismic.asLink(event) || ''"
    class="relative my-4 block overflow-hidden border border-charcoal-25 bg-white/25 transition-all duration-500 hover:bg-white md:flex"
  >

    <PrismicImage
      v-if="event.data.featured_image.url"
      :field="event.data.featured_image"
      class="order-last object-cover md:w-80"
    />

    <div class="p-6 md:flex-1 md:p-10">

      <div class="mb-4">
        <span class="mr-1 inline-block rounded-sm bg-green-25 px-2 py-0.5 text-caption text-green-100 md:text-desktop-caption">
          {{ event.data.type }}
        </span>
        <span class="mr-1 inline-block rounded-sm bg-rust-25 px-2 py-0.5 text-caption text-charcoal-75 md:text-desktop-caption">
          {{ event.data.audience }}
        </span>
      </div>

      <!-- Ending Soon Message (Displays if End Date is within 10 days) -->
      <!-- <EventsTicker v-if="dayjs(event.data.end_date).isBetween(dayjs(), dayjs().add(10, 'days'))" /> -->

      <h2 class="text-header2">{{ event.data.title }}</h2>
      <span
        v-if="dayjs(event.data.start_date).isSame(event.data.end_date, 'day')"
        class="text-large-copy"
      >
        {{ dayjs(event.data.start_date).format("DD MMMM YYYY, hh:mm A") }}
      </span>
      <span
        v-else
        class="text-large-copy"
      >
        {{ dayjs(event.data.start_date).format("DD MMMM") }}
        -
        {{ dayjs(event.data.end_date).format("DD MMMM YYYY") }}
      </span>

      <!-- Pricing Tags -->
      <div class="mt-10">
        <div
          v-if="event.data.day_pass"
          class="mb-1 mr-1 block rounded-sm bg-yellow-100 px-2 py-0.5 text-center text-caption text-charcoal-100 md:inline-block md:text-desktop-caption"
        >
          Included with Day Pass
        </div>

        <div
          v-if="event.data.admission_fees.length"
          class="mb-1 mr-1 block rounded-sm bg-charcoal-25 px-2 py-0.5 text-center  text-caption text-charcoal-100 md:inline-block md:text-desktop-caption"
        >
          Admission fees apply
        </div>

        <div
          v-else-if="event.data.entry_by_donation"
          class="mb-1 mr-1 block rounded-sm bg-green-50 px-2 py-0.5 text-center text-caption text-charcoal-100 md:inline-block md:text-desktop-caption"
        >
          Entry by Donation
        </div>

        <div
          v-else
          class="mb-1 mr-1 block rounded-sm bg-green-50 px-2 py-0.5 text-center text-caption text-charcoal-100 md:inline-block md:text-desktop-caption"
        >
          Free Entry
        </div>
      </div>

      <UIButton
        type="dark"
        label="Learn More"
        class="mt-4 block md:inline-block"
      />

    </div>

  </a>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
import type { Content } from "@prismicio/client";

const { useCurrencyFormat } = useFilters();
const prismic = usePrismic();

const props = defineProps<{
  event: Content.EventsDocument;
}>();
</script>
